module.exports = __webpack_public_path__ + "static/media/contact-us_icon.53ce2fac.jpg";